import { Component, OnInit } from '@angular/core';
import { BlockUIService } from './services/blockui.service';
import { NgBlockUI, BlockUI } from 'ng-block-ui';
import { Authathenticate } from './models/authAuthenticate';
import { SessionService } from './services/session.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  template: `  <block-ui message="Deafult Message">
  <router-outlet></router-outlet>
  </block-ui>`,
  styleUrls: ['./app.component.css']
})

export class AppComponent implements OnInit {
  subscription: any;
  private user: Authathenticate = new Authathenticate();
  @BlockUI() blockUI: NgBlockUI;

  constructor(
    private blockUIService: BlockUIService,
    private sessionService: SessionService,
    private router: Router,
  ) {

    this.blockUIService.blockUIEvent$.subscribe(res => {
      this.handleBlockUI(res)
    });


  }
  ngAfterViewInit() {

    if(window.location.pathname === "/login" || window.location.pathname === "/"){
      this.subscription = this.sessionService.sessionEvent$.subscribe({
        next: res => {
          user => this.onAuthenication(user);
        }
      }
      );
    }


  }
  private onAuthenication(user: Authathenticate): void {

    this.user = user;
    if (this.user.userAuthenticate == false) {
      this.router.navigate(['login']);
    }

  }
  handleBlockUI(block: Boolean) {
    if (block) {
      this.blockUI.start("Loading ...");

    } else {
      this.blockUI.stop();
    }
  }
  ngOnInit(): void {
    //console.log("started")
  }
}
